import React, { FC } from 'react'
import DashboardSwitch from '../components/dashboard/DashboardSwitch'
import { Layout } from '@sistemiv/s-components'
import SideNavMenu from '../components/layout/SideNavMenu'
import TopNav from '../components/layout/TopNav'
import { useResponsive } from '../components/context/ResponsiveContextProvider'

const Dashboard: FC = () => {
  const { isMobile } = useResponsive()

  return (
    <Layout topNavComponent={<TopNav />} sideMenuComponent={!isMobile ? <SideNavMenu isSideMenuOpen={true} /> : null}>
      <DashboardSwitch />
    </Layout>
  )
}

export default Dashboard
